/*    
<summary>
  This functional component "AddOptionMenu" defines the props like initial values and functions for the child form component.
  Developer:Sahil Bharti, Created Date:06-January-2025
</summary>
<returns>Returns JSX</returns>
*/

import { cloneDeep } from "lodash";
import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useHistory } from "react-router-dom";
import RoutesConstants from "../../../../constants/routes.constant";
import { useStore } from "../../../../contexts/store-provider";
import { IAddCustomer } from "../../../../models/forms/IAddCustomerManagement";
import ConfirmPopup from "../../../../shared-components/popup/confirm/confirm-popup";
import ConfirmPopupHOC from "../../../../shared-components/popup/confirm/confirm-popup-hoc";
import { formatMessage } from "../../../../translations/format-message";
import CustomerRegistrationForm from "../forms/customer-registration-form";

const AddEditCustomerRegistration = (props: any) => {
  const { customerManagementStore, storeManagementStore, authStore } =
    useStore();
  const {
    authenticateCustomerAuthCodeState,
    generateCustomerAuthCodeState,
    GenerateCustomerAuthCodeService,
    resetGenerateCustomerAuthCodeState,
    resetAuthenticateCustomerAuthCode,
    AppointmentRegisterCustomerlogin
  } = authStore;
  const {
    inProgress,
    resetAddUpdateCustomerState,
    resetCustomerDetail,
    customerState,
    customerDetail,
    addUpdateCustomerState,
    AddCustomerRegister,
    isCustomerValidated,
    customerValidatedData,
    resetValidateCustomerState,
    resetIsCustomerValidated
  } = customerManagementStore;

  const history = useHistory();

  const { storeState } = storeManagementStore;

  const initialValues: IAddCustomer = {
    ...customerDetail,
    Password: customerDetail?.Id ? "*********" : "",
  };

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "addUpdateCustomerError" of the useEffect changed.
   */
  useEffect(() => {
    if (addUpdateCustomerState.error) {
      toast.error(formatMessage(addUpdateCustomerState.error));
      resetAddUpdateCustomerState();
    }
  }, [addUpdateCustomerState.error]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "addUpdateCustomerState.success" of the useEffect changed.
   */
  useEffect(() => {
    if (addUpdateCustomerState.success) {
      resetAddUpdateCustomerState();
      toast.success(formatMessage("customer_registered_success"));
      setTimeout(() => {
        resetAuthenticateCustomerAuthCode();
        resetValidateCustomerState();
        resetIsCustomerValidated();
        history.push(RoutesConstants.CustomerLogin);
      }, 2000);
    }
  }, [addUpdateCustomerState.success]);

  useEffect(() => {
    if (isCustomerValidated == true) {
      GenerateCustomerAuthCodeService({
        Email: customerValidatedData.Email,
        KanaName: customerValidatedData.KanaName,
        AuthType: customerValidatedData.AuthType,
      });
    }
  }, [isCustomerValidated]);

  useEffect(() => {
    if (generateCustomerAuthCodeState.error) {
      toast.error(formatMessage(generateCustomerAuthCodeState.error));
      resetAddUpdateCustomerState();
      resetGenerateCustomerAuthCodeState();
    }
  }, [generateCustomerAuthCodeState.error]);

  const registerAndLoginCustomer = (data: any) =>{
    AppointmentRegisterCustomerlogin({
      Email: data.Email,
      Password: data.Password
    })
  }

  /**
   * This function adds the customer when "Id < 0" and updates the Existing customer when Id > 0 by providing form values to the
   * correponding function
   */
  const onSubmitForm = (values: any) => {
    let tempValues = cloneDeep(values);
    tempValues.CustomerType = 1;
    AddCustomerRegister(tempValues, registerAndLoginCustomer);
  };

  useEffect(() => {
    resetCustomerDetail();
  }, []);

  return (
    <React.Fragment>
      <CustomerRegistrationForm
        initialValues={initialValues}
        id={props.id}
        submitHandler={onSubmitForm}
        getCustomerLoading={
          customerState.inProgress ||
          addUpdateCustomerState.inProgress ||
          storeState.inProgress ||
          inProgress ||
          authenticateCustomerAuthCodeState.inProgress ||
          generateCustomerAuthCodeState.inProgress
        }
      />
    </React.Fragment>
  );
};

export default observer(AddEditCustomerRegistration);
